import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('ep-timeline-comment-header')
export class EPTimelineCommentHeader extends LitElement {

  render() {
    return html`
      <div style="display: flex; align-items: center;">
        <span>
          <slot></slot>
        </span>
        <span style="margin-left: auto;">
          <slot name="trailing"></slot>
        </span>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
      width: 100%;
      --text-default: rgb(31, 35, 40);
      --text-muted: rgb(101, 109, 118);
      --border-muted: rgb(216, 222, 228);
      --border-default: rgb(208, 215, 222);
      --badge-background: rgb(234, 238, 242);
      --canvas-subtle: rgb(246, 248, 250);
    }

    ::slotted([slot=header]) {
      margin-top: 0;
      margin-bottom: 0;
      /* color: var(--text-muted); */
    }
    ::slotted(strong) {
      color: var(--text-default);
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-timeline-comment-header': EPTimelineCommentHeader
  }
}
